import { get, del, upload, post, put } from '../request';

export async function fetchMraModels({ mraService }, authenticationToken) {
  const url = `${mraService}/mra/models`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteMraModel(
  { mraService },
  authenticationToken,
  { modelId },
) {
  const url = `${mraService}/mra/model/${modelId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function createMraModel(
  { mraService },
  authenticationToken,
  { modelName, modelDescription, file },
) {
  const url = `${mraService}/mra/models`;
  const data = new FormData();
  data.append('modelName', modelName);
  data.append('modelDescription', modelDescription);
  data.append('file', file);
  const { body } = await upload(authenticationToken, url, data);
  return body;
}

export async function fetchMraModel(
  { mraService },
  authenticationToken,
  { modelId },
) {
  const url = `${mraService}/mra/model/${modelId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMraAnalysisModel(
  { equityfinderService },
  authenticationToken,
  { analysisId },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysis/${analysisId}/mracalc`;
  const { body } = await post(authenticationToken, url, null, {
    contentType:
      'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
  });
  return body;
}

export async function fetchMraAnalysisNoi(
  { equityfinderService },
  authenticationToken,
  { analysisId },
) {
  const url = `${equityfinderService}/equityfinder/property/regressionanalysis/${analysisId}/mracalcnoi`;
  const { body } = await post(authenticationToken, url, null, {
    contentType:
      'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
  });
  return body;
}

export async function calculateMraModel(
  { mraService },
  authenticationToken,
  { modelId, year = 2018, calculateOption, modelParameters, modelData },
) {
  const url = `${mraService}/mra/model/${modelId}/calculate`;
  const data = {
    year,
    calculateOption,
    modelParameters,
    modelData,
  };
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function persistMraModelSetting(
  { mraService },
  authenticationToken,
  { modelId, settings },
) {
  const url = `${mraService}/mra/model/${modelId}/settings`;
  const { body } = await put(authenticationToken, url, {
    modelSettings: settings,
  });
  return body;
}
